import React, {useCallback, useRef} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getIsCheckInAtLeastTwoDaysAway} from 'modules/search/selectors'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const filterKeys = ['freeCancellation']

interface Props {
  isActive?: boolean
}

export const FreeCancellationPill: React.FC<Props> = ({isActive = false}) => {
  const {formatMessage} = useIntl()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isCheckInAtLeastTwoDaysAway = useSelector(
    getIsCheckInAtLeastTwoDaysAway
  )

  const {submitFilters} = useFiltersForm(filterKeys)

  const handlePillClick = useCallback(() => {
    buttonRef.current?.blur()

    const updatedFilters = {
      freeCancellation: (isActive ? undefined : '1') as BooleanUrlParam
    }

    submitFilters(updatedFilters)
  }, [isActive, submitFilters])

  if (!isCheckInAtLeastTwoDaysAway) return null

  return (
    <Pill
      ref={buttonRef}
      isSelected={isActive}
      dataId="cancellationPenalties.freeCancellationfs"
      onClick={handlePillClick}
      iconStart={<Icon name="CalendarCheck4" />}
      iconEnd={isActive && <Icon name={'Close'} />}
    >
      {formatMessage(filterMessages.freeCancellationTitle)}
    </Pill>
  )
}
